import { Step, StepButton, Stepper } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';
import { useParams } from 'react-router-dom';

import Text from '../../base/text';

import * as GQL from '~/graphql/generated/client';
import { useSetCurrentProjectStageMutation } from '~/graphql/generated/client';

interface Props {
  className?: string;
  projectStages: GQL.Stage[] | undefined | null;
  isAllowed: boolean;
}

const LifecycleStepperImpl: React.FC<Props> = ({
  projectStages,
  isAllowed,
}) => {
  const [activeStep, setActiveStep] = React.useState(0);

  const [setStage] = useSetCurrentProjectStageMutation();
  const { projectId } = useParams();

  const handleComplete = (id: string) => {
    if (isAllowed) {
      setStage({
        variables: { input: { projectId: projectId!, stageId: id } },
      });
    }
  };

  React.useEffect(() => {
    projectStages?.map((e, index) => {
      if (e.enabled) {
        setActiveStep(index + 1);
      }
    });
  });
  return (
    <>
      <Stepper nonLinear activeStep={activeStep}>
        {projectStages?.map((item, index) => (
          <Step key={item.description} completed={item?.enabled ?? false}>
            <StepButton
              color="inherit"
              onClick={() => handleComplete(item._id)}
            >
              <Text sz="bold-body16">{item.name}</Text>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </>
  );
};
export const LifecycleStepper = muiStyled(LifecycleStepperImpl)(({ theme }) => {
  return css``;
});
